<template>
  <div>
    <div class="row">
      <div class ="col-12 text-center">
        <h1>Cuenta de usuario</h1>
      </div>
    </div>
    <div class="row">
      <div class="container">
        <account-summary/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters } from 'vuex';
import AccountSummary from './accountSummary.vue';

export default {
  name: 'userPage',
  components: {
    'account-summary': AccountSummary,
  },
  computed: {
    ...mapGetters('usersModule', ['user']),
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped>

</style>
